import { CheckCircle, RefreshCw } from "lucide-react";
import { OutboxStatus } from "../types/outbox";

export function OutboxStatusIcon({ status }: { status: OutboxStatus }) {
  switch (status) {
    case OutboxStatus.InProgress:
      return <RefreshCw className="size-5" />;
    case OutboxStatus.Sent:
      return <CheckCircle className="text-primary size-5" />;
    default:
      return null;
  }
}
